import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const AccordionLink = ({ title, path, exclude, id = '' }) => {
  const { pathname } = useRouter()

  function isActive(pathname, path, exclude) {
    let value = pathname.startsWith(path)

    if (value && exclude.length) {
      let isExcluded = exclude.find((item) => pathname.startsWith(item))

      if (isExcluded) {
        value = false
      }
    }

    return value
  }

  return (
    <Link href={path}>
      <a
        className={classNames('d-block', {
          active: isActive(pathname, path, exclude)
        })}
        id={id}
      >
        {title}
      </a>
    </Link>
  )
}

AccordionLink.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  exclude: PropTypes.array,
  id: PropTypes.string
}

AccordionLink.defaultProps = {
  exclude: []
}

export default AccordionLink
